<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>

  <ng-container *ngFor="let source of dataSources">
    <table mat-table [dataSource]="source.dataSource" *ngIf="source.hasData()">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? source.masterToggle() : null"
                        [checked]="source.selection.hasValue() && source.allSelected()"
                        [indeterminate]="source.selection.hasValue() && !source.allSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? source.toggle(row) : null"
                        [checked]="source.selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{source.title}}</th>
        <td mat-cell *matCellDef="let config"> {{config.path}} </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let config"> {{config.state}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="source.displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: source.displayedColumns;"></tr>
    </table>
  </ng-container>
</div>

<div mat-dialog-actions>
  <ng-container *ngIf="errorMessage()">
    <div class="error-message">{{errorMessage()}}</div>
  </ng-container>
  <button (click)="cancel()" mat-button>Cancel</button>
  <button mat-button [disabled]="!valid()" (click)="publish()">Publish</button>
</div>
